export default __webpack_public_path__ + "static/media/algolia-blue-mark.8b893f6f.svg";